import { render, staticRenderFns } from "./VideoClip.vue?vue&type=template&id=1a256ffa&scoped=true"
import script from "./VideoClip.vue?vue&type=script&lang=js"
export * from "./VideoClip.vue?vue&type=script&lang=js"
import style0 from "./VideoClip.vue?vue&type=style&index=0&id=1a256ffa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a256ffa",
  null
  
)

export default component.exports